import type { AdminLicenseStatsDB } from "@KassaroAB/shared/types/adminLicenseStats";
import { api } from "../utils/api";

export const getAdminLicenseStatsApi = async (
  fromDate: string,
  toDate: string,
  limit: number = 50,
  cursor: string | null = null
): Promise<Array<AdminLicenseStatsDB & { id: string }>> => {
  const params = new URLSearchParams({
    fromDate,
    toDate,
    limit: limit.toString(),
  });
  if (cursor) {
    params.set("cursor", cursor);
  }
  return api.get<Array<AdminLicenseStatsDB & { id: string }>>(
    `admin/stats/licenses?${params.toString()}`
  );
};

export const computeAdminLicenseStatsApi = async (): Promise<{
  date: string;
}> => {
  return api.post<{ date: string }>("admin/stats/licenses/compute", {});
};
